import { ReactNode } from 'react'

import clsx from 'clsx'

export const FLOAT_HEIGHT = 40

interface Props {
  children?: ReactNode
  width?: number | '100%'
  isFixed?: boolean
  scrollBar?: ReactNode
  pager?: ReactNode
  border?: boolean
}

const BottomFloat = ({ children, width, isFixed = false, scrollBar, pager, border = false }: Props) => {
  return (
    <div
      className={clsx(
        'bg-fill-primary flex flex-col',
        isFixed ? 'z-fixed-bottom fixed bottom-0' : 'mt-auto rounded-b-xl',
        border && 'border-secondary border-t'
      )}
      style={{ width }}
    >
      {scrollBar}
      <div className='relative flex h-10 w-full items-center justify-center gap-x-2'>
        {pager && <div className={'absolute left-2 flex'}>{pager}</div>}
        {children}
      </div>
    </div>
  )
}

export default BottomFloat
